"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectPropTypes = exports.SelectItemPropTypes = exports.OptgroupPropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cnbuilder = require("cnbuilder");
var _arrowDownDefault = _interopRequireDefault(require("@teladoc/pulse/icons/arrow-down-default.svg"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _useLabelValidation = _interopRequireDefault(require("../Form/use-label-validation"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _SelectModule = _interopRequireDefault(require("./Select.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["classNameRoot", "classNameControl", "classNameItem", "testAttrRoot", "testAttrControl", "testAttrItem", "testAttrError", "i18nItemLabel", "name", "id", "items", "readOnly", "disabled", "error", "customValidationError", "icon", "helpNode", "label", "placeholder", "required", "loading", "defaultValue", "onChange", "onFocus", "onInvalid", "value"],
  _excluded2 = ["optgroup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function renderItem(_ref, i) {
  let {
    label = '',
    value = '',
    disabled = false
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
    value: value,
    disabled: disabled,
    children: label
  }, i);
}
function renderOptgroup(_ref2) {
  let {
    label,
    optgroup
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("optgroup", {
    label: label,
    children: optgroup.map(renderItem)
  }, label);
}
const Select = _ref3 => {
  let {
      classNameRoot,
      classNameControl,
      classNameItem,
      testAttrRoot,
      testAttrControl,
      testAttrItem,
      testAttrError,
      i18nItemLabel,
      name,
      id,
      items,
      readOnly,
      disabled,
      error,
      customValidationError,
      icon,
      helpNode,
      label,
      placeholder,
      required,
      loading,
      defaultValue,
      onChange,
      onFocus,
      onInvalid,
      value
    } = _ref3,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  const {
    ref,
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  });
  const [internalValue, setInternalValue] = (0, _react.useState)(value);
  const isWindows = _environment.default.isWindows();
  const onChangeCallback = evt => {
    const selectedItem = items.reduce((options, _ref4) => {
      let {
          optgroup
        } = _ref4,
        item = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
      return optgroup ? [...options, ...optgroup] : [...options, item];
    }, []).find(_ref5 => {
      let {
        value: itemValue
      } = _ref5;
      return itemValue === evt.target.value;
    });
    setValidationState(null);
    setInternalValue(selectedItem.value);
    if (onChange) {
      onChange(selectedItem);
    }
  };
  const newDefaultValue = placeholder && !defaultValue ? '' : defaultValue;
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  (0, _useLabelValidation.default)(label, i18nItemLabel, rest);
  (0, _react.useEffect)(() => {
    setValidationState(null);
  }, [disabled, setValidationState]);
  (0, _react.useEffect)(() => {
    setInternalValue(value);
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_SelectModule.default.root, {
      [_SelectModule.default.isLoading]: loading
    }, {
      [_SelectModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_SelectModule.default.readOnly]: readOnly
    }, {
      [_SelectModule.default.containsError]: !isValid
    }, {
      [_SelectModule.default.disabled]: disabled
    }, classNameRoot)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    "data-testid": testAttrRoot,
    children: [label && /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_SelectModule.default.label, label.props.className),
      htmlFor: id,
      required
    }), helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _SelectModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _cnbuilder.cnb)(_SelectModule.default.control, classNameControl),
      "data-testid": testAttrControl,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("select", _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        ref: ref,
        id: id,
        "data-testid": testAttrItem,
        className: (0, _cnbuilder.cnb)(_SelectModule.default.item, {
          [_SelectModule.default.hasIcon]: Boolean(icon)
        }, classNameItem),
        name: name,
        required: required,
        readOnly: readOnly,
        disabled: disabled,
        "aria-label": i18nItemLabel
      }, defaultValue && internalValue ? {
        value: internalValue
      } : {
        value: newDefaultValue || internalValue
      }), describedBy.length && {
        'aria-describedby': describedBy.join(' ')
      }), {}, {
        onFocus: onFocus,
        onChange: onChangeCallback
      }, !isWindows && {
        'aria-errormessage': "".concat(errorId)
      }), {}, {
        "aria-invalid": !isValid
      }, rest), {}, {
        children: [placeholder && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "",
          disabled: true,
          selected: true,
          children: placeholder
        }), items.map((item, i) => item.optgroup ? renderOptgroup(item) : renderItem(item, i))]
      })), readOnly && !disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _SelectModule.default.lock,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {})
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowDownDefault.default, {
          className: _SelectModule.default.arrow
        }), icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _SelectModule.default.icon,
          children: icon
        }), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          className: _SelectModule.default.loader,
          testAttr: "loader",
          inline: true,
          size: "small"
        })]
      })]
    }), showInvalid && /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })]
  }));
};
const SelectItemPropTypes = exports.SelectItemPropTypes = {
  /** The label to display visually in the Select. */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  /** The value to return when a selection is made. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  /** Whether the option is disabled. */
  disabled: _propTypes.default.bool
};
const OptgroupPropTypes = exports.OptgroupPropTypes = {
  /** The optgroup label within the list of options */
  label: _propTypes.default.string,
  /** An array of options with label/value pairs */
  optgroup: _propTypes.default.arrayOf(_propTypes.default.shape(SelectItemPropTypes))
};
const SelectPropTypes = exports.SelectPropTypes = {
  /** Additional class(es) to add to the root element. */
  classNameRoot: _propTypes.default.string,
  /** Additional class(es) to add to the control element. */
  classNameControl: _propTypes.default.string,
  /** Additional class(es) to add to the select element. */
  classNameItem: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's root element. */
  testAttrRoot: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's control element. */
  testAttrControl: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's select item element. */
  testAttrItem: _propTypes.default.string,
  /** The name of the test attribute to associate to the component's error element. */
  testAttrError: _propTypes.default.string,
  /** The aria-label to apply to the select. */
  i18nItemLabel: _propTypes.default.string,
  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,
  /** A unique ID which is used to identify this element for accessibility purposes. */
  id: _propTypes.default.string.isRequired,
  /** A custom label (typically a Label component) to display above the select. */
  label: _propTypes.default.element,
  /** Adds an initial, unselectable item to display in the dropdown. */
  placeholder: _propTypes.default.string,
  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,
  /** Specifies that the select is read-only. */
  readOnly: _propTypes.default.bool,
  /** Whether to add a loading indicator in the select. */
  loading: _propTypes.default.bool,
  /** Disallows user interaction. */
  disabled: _propTypes.default.bool,
  /** An array of options or an array of option groups. */
  items: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape(OptgroupPropTypes)), _propTypes.default.arrayOf(_propTypes.default.shape(SelectItemPropTypes))]).isRequired,
  /** A custom icon (typically one of the Icon components) to show in the left side of the select field. */
  icon: _propTypes.default.element,
  /** A custom help element to place below the select. */
  helpNode: _propTypes.default.node,
  /** The default value to display in the select when mounted. */
  defaultValue: _propTypes.default.string,
  /** A custom validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,
  /** A custom validation error (typically a FormElementError component) to display and override any other possible error passed when this component is part of a form and is invalid. */
  customValidationError: _propTypes.default.element,
  /**
   * Function to execute when the select changes.
   *
   * @param {Object} item - The value/label pair of the selection.
   */
  onChange: _propTypes.default.func,
  /**
   * Function to execute when the select is focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onFocus: _propTypes.default.func,
  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func,
  /** The value of the selected item in the dropdown. */
  value: _propTypes.default.string
};
Select.defaultProps = {
  testAttrRoot: 'select-root',
  testAttrControl: 'select-control',
  testAttrItem: 'select-item',
  testAttrError: 'select-error'
};
var _default = exports.default = Select;